import { render } from "./SelectService.vue?vue&type=template&id=f6c04480&scoped=true"
import script from "./SelectService.vue?vue&type=script&lang=js"
export * from "./SelectService.vue?vue&type=script&lang=js"

import "./SelectService.vue?vue&type=style&index=0&id=f6c04480&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6c04480"]])

export default __exports__